import { useQuery } from '@tanstack/react-query';
import { health } from '../api/endpoints/auth';
import { getOpenApi } from '../api/endpoints/openapi';

/** /health — polled once a minute for the sidebar's connection indicator. */
export function useHealth() {
  return useQuery({ queryKey: ['health'], queryFn: health, refetchInterval: 60_000, retry: false });
}

export function useOpenApi() {
  return useQuery({ queryKey: ['openapi'], queryFn: getOpenApi, staleTime: 10 * 60_000 });
}
